(function () {'use strict';}());
angular.module("elidb").directive('resultsDetailView', function($document,$timeout, ELIService) {
    return {
      restrict: 'A',
      templateUrl: __DIR__+'/views/results-detail.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.shareResourceSearch = function(id) {
          var data = $scope.storedState;
          data.id = id;
          ELIService.createUserSpecificLink(data).then(function(results){
          window.prompt("Please copy the link below to share your search results.", results.data.lid);
          });
        };

        $scope.getContact = function() {
          if($scope.lang === "es" && $scope.detailView.contact_es) return $scope.detailView.contact_es;
          else return $scope.detailView.contact;
        };

        $scope.getFormattedEmailLink = function (detail){
        	if(!detail) return;
        	var subject = $scope.tech.txtDirRDVShare.value;
        	var body = $scope.tech.txtDirRDVUsing.value + " "  + detail.name.replace(/&/gim,"+") + ": " + "https://directory.exceptionallives.org/#id="+detail.id;
        	var email ="?subject="+subject+"&body="+body;
        	return encodeURI(email);
        };
      }  
    };
  });